"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../../utils");
const Layout = ({ children, className, maxWidth = '1280px' }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, utils_1.cn)('mx-auto p-8', className), style: { maxWidth }, children: children }));
};
exports.Layout = Layout;
exports.Layout.displayName = 'Layout';
